import { getRequest, getRequestV2 } from '../../methods';
import { buildQueryString } from '../../lib/query';

const getCyclesRequest = () => getRequest('cycles');
const getCyclesForOrgUnitRequest = params =>
  getRequest(`cycles?${buildQueryString(params)}`);
const getPhasesRequest = () => getRequestV2('cycles/phases');

const cycles = {
  getCyclesRequest,
  getCyclesForOrgUnitRequest,
  getPhasesRequest,
};

export default cycles;
